<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
// hooks
import { useStrapiSiteSeo } from '@api/strapi/site-seo/strapi-site-seo.hook'
import { useStrapiSchemaSettings } from '@api/strapi/schema-settings/strapi-schema-settings.hook'
import { useStrapiGlobalSettings } from '@api/strapi/global-settings/strapi-global-settings.hook'
import { useStrapiCtaSettings } from '@api/strapi/cta-settings/strapi-cta-settings.hook'
import { useSiteSeoHead } from '@composables/seo/use-site-seo-head.hook'
// components
import { TheHeader } from '@Widgets/Headers'
import { TheFooter } from '@Widgets/Footers'
// async components
const LayoutBackground = defineAsyncComponent(() => import('@Widgets/Layouts/LayoutBackground.vue'))

defineOptions({
  name: 'SeoLayout',
})

// The decorative page background stays only on /help-center and /help-center/*
// (the redesigned pages own their surfaces). Route-based, matching TheHeader.
const route = useRoute()

const refShowBackground = computed<boolean>(() => route.path.startsWith('/help-center'))

const { refSiteSeo } = await useStrapiSiteSeo()
const { refSchemaSettings } = await useStrapiSchemaSettings()

await useStrapiGlobalSettings()
await useStrapiCtaSettings()

useSiteSeoHead(refSiteSeo, refSchemaSettings)
</script>

<template>
  <div class="layout">
    <LayoutBackground v-if="refShowBackground" />
    <TheHeader />
    <main class="layout__main">
      <slot />
    </main>
    <TheFooter />
  </div>
</template>
